export default {
  transactions: [],
  transactionsCoutn: 0,
  transaction_income_type: {
    results: [],
  },
  transaction_cashbox: {
    results: [],
  },
  transactionsIncomeCharts: [],
  transactionsIncomeChartsCount: 0,
}
